// extracted by mini-css-extract-plugin
module.exports = {"mainColumn":"styles_mainColumn__3Wm82","jobEditor":"styles_jobEditor__3kzwk","buttons":"styles_buttons__340su"};